import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import {
  CardElements,
  CardsCommonElements,
  Classes,
  Colors,
  GeneralCardSubElements,
} from "@/types";
import {
  canCardVModel,
  getBreakpointClasses,
  getBreakpoint,
  hoverItem,
} from "@/utils";
import { getCssColor, getIonicColor, isCourse, isGeneral } from "@/utils";
import { IonItem } from "@ionic/vue";
import {
  nextTick,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
  watch,
} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardItem',
  props: {
  card: {
    type: Object as PropType<CardElements>,
    required: true,
  },
  detail: {
    type: Boolean,
    default: true,
  },
  colors: Object as PropType<Colors<GeneralCardSubElements>>,
  classes: Object as PropType<Classes<CardsCommonElements>>,
},
  emits: ["execute_link", "signal_event", "update:card"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "5ba98f56": (_unref(css_hover_color)),
  "5b3483c8": (_unref(css_background_color))
}))

const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
};




const local_hovered = ref(false); // Dummy variable to keep track of reactivity, since it seems not possible to catch props.class.hovered changes
const css_hover_color =
  props.colors?.hover != undefined
    ? getCssColor(props.colors.hover)
    : undefined;
const css_background_color =
  props.colors?.background != undefined
    ? getCssColor(props.colors.background)
    : undefined; //<!-- TODO (6): valutare colore separato per ion-item

const breakpoint = ref(getBreakpoint(window.innerWidth));
const card_ref = ref(props.card);

if (isGeneral(props.card) && canCardVModel(props.card)) {
  watch(
    () => props.card,
    (value) => {
      card_ref.value = value;
    }
  );
  watch(
    () => card_ref.value,
    (value) => {
      emit("update:card", value);
    }
  );
}

if (props.classes?.item != undefined) {
  onMounted(() =>
    nextTick(() => {
      window.addEventListener("resize", updateBreakpoint);
    })
  );

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updateBreakpoint);
  });
}

return (_ctx: any,_cache: any) => {
  const _component_general_card = _resolveComponent("general-card")!
  const _component_course_card = _resolveComponent("course-card")!

  return (_openBlock(), _createBlock(_unref(IonItem), {
    lines: __props.colors?.list_borders != undefined ? 'inset' : 'none',
    detail: __props.detail && _unref(isGeneral)(__props.card) && __props.card.link != undefined,
    color: !local_hovered.value ? _unref(getIonicColor)(__props.colors?.background) : undefined,
    class: _normalizeClass([{
      ..._unref(getBreakpointClasses)(__props.classes?.item, breakpoint.value),
      background:
        !local_hovered.value &&
        __props.colors?.background != undefined &&
        _unref(getIonicColor)(__props.colors?.background) == undefined,
      hovered: local_hovered.value,
    }, "ion-no-padding"]),
    onMouseenter: _cache[11] || (_cache[11] = ($event: any) => {
      if (props.colors?.hover != undefined) {
        local_hovered.value = true;
        _unref(hoverItem)(__props.card, true);
      }
    }),
    onMouseleave: _cache[12] || (_cache[12] = ($event: any) => {
      if (props.colors?.hover != undefined) {
        local_hovered.value = false;
        _unref(hoverItem)(__props.card, false);
      }
    })
  }, {
    default: _withCtx(() => [
      (_unref(isCourse)(card_ref.value))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ('layout' in card_ref.value)
              ? (_openBlock(), _createBlock(_component_general_card, {
                  key: 0,
                  onExecute_link: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('execute_link'))),
                  onSignal_event: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('signal_event'))),
                  id: card_ref.value.id,
                  content: card_ref.value.content,
                  "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((card_ref.value.content) = $event)),
                  layout: card_ref.value.layout,
                  hovered: local_hovered.value,
                  colors: card_ref.value.colors,
                  classes: card_ref.value.classes
                }, null, 8, ["id", "content", "layout", "hovered", "colors", "classes"]))
              : (_openBlock(), _createBlock(_component_course_card, {
                  key: 1,
                  onExecute_link: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('execute_link'))),
                  onSignal_event: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('signal_event'))),
                  content: card_ref.value.content,
                  credits: card_ref.value.credits,
                  enrollment: card_ref.value.enrollment,
                  colors: __props.card.colors
                }, null, 8, ["content", "credits", "enrollment", "colors"]))
          ], 64))
        : (_unref(isGeneral)(card_ref.value))
          ? (_openBlock(), _createBlock(_component_general_card, {
              key: 1,
              onExecute_link: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('execute_link'))),
              onSignal_event: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('signal_event'))),
              id: card_ref.value.id,
              title: card_ref.value.title,
              "onUpdate:title": _cache[7] || (_cache[7] = ($event: any) => ((card_ref.value.title) = $event)),
              subtitle: card_ref.value.subtitle,
              "onUpdate:subtitle": _cache[8] || (_cache[8] = ($event: any) => ((card_ref.value.subtitle) = $event)),
              content: card_ref.value.content,
              "onUpdate:content": _cache[9] || (_cache[9] = ($event: any) => ((card_ref.value.content) = $event)),
              side_element: card_ref.value.side_element,
              "onUpdate:side_element": _cache[10] || (_cache[10] = ($event: any) => ((card_ref.value.side_element) = $event)),
              layout: card_ref.value.layout,
              selected: card_ref.value.selected,
              hovered: local_hovered.value,
              link: card_ref.value.link,
              colors: card_ref.value.colors,
              classes: card_ref.value.classes
            }, null, 8, ["id", "title", "subtitle", "content", "side_element", "layout", "selected", "hovered", "link", "colors", "classes"]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["lines", "detail", "color", "class"]))
}
}

})